import { render } from "./Accueil.vue?vue&type=template&id=72acefd8"
import script from "./Accueil.vue?vue&type=script&lang=js"
export * from "./Accueil.vue?vue&type=script&lang=js"

import "./Accueil.vue?vue&type=style&index=0&id=72acefd8&lang=scss"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__